import Ajax from '@/lib/ajax'

export default {
  getList(
    MaxResultCount: number,
    currentPage: number,
    keyWord?: string,
    sorting?: string
  ) {
    let params = {
      keyWord,
      MaxResultCount,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * MaxResultCount,
    }
    return Ajax.get(`/api/distribution/distributionProduct`, {
      params: params,
    })
  },
  create(data: any) {
    return Ajax.post(`/api/distribution/distributionProduct`, data)
  },
  createBatch(data: any[]) {
    return Ajax.post(`/api/distribution/distributionProduct/batch`, data)
  },
  update(id: string, data: any) {
    return Ajax.put(`/api/distribution/distributionProduct/${id}`, data)
  },
  deleteItem(ids: string[]) {
    return Ajax.delete(`/api/distribution/distributionProduct`, {
      params: { ids },
    })
  },
}
